
    var riot = require('riot')
    //src: starling/src/tags/links.html
riot.tag2('links',
  '<svg ref="linksSvg" id="links-svg"> <filter id="linkBlur" width="150%" height="150%"> <fegaussianblur stddeviation="2" result="blur"></fegaussianblur> </filter> <defs> <marker id="new-link-diamond" markerwidth="40" markerheight="40" refx="5" refy="5" orient="auto" markerunits="userSpaceOnUse" viewbox="-2 -2 20 20"> <path d="M 5,1 L 9,5 5,9 1,5 z" class="link-diamond-halo"></path> <path d="M 5,1 L 9,5 5,9 1,5 z" class="link-diamond"></path> </marker> </defs> <g class="links"> <g data-is="link" each="{this.getLinks()}" instance="{this}"></g> </g> </svg> <div> <link-endpoint each="{this.getEndPoints()}" instance="{this}" canvas="{parent.canvas}"></link-endpoint> </div>',
  'links svg,[data-is="links"] svg{ width: 10000px; height: 100000px; pointer-events: none; overflow: visible; }',
  '', function(opts) {
'use strict';

var _this = this;

var _geom = require('lib/geom');

this.canvas = opts.canvas;
this.canvas.linksTag = this;
this.isFirefox = navigator.userAgent.indexOf("Firefox") > 0;

this.getDragLinkPath = function (mag) {
  if (!_this.canvas.relDrag || !_this.canvas.linkDragging) {
    return 'M 0 0 L 0 0';
  }
  var p = _this.canvas.relDrag;

  var _canvas$getMatrix = _this.canvas.getMatrix(),
      scale = _canvas$getMatrix.scale;

  var endpoint = (0, _geom.movePointTowardsPoint)({
    subject: {
      x: p.x2,
      y: p.y2
    },
    object: {
      x: p.x1,
      y: p.y1
    },
    magnitude: mag / scale
  });

  var path = 'M ' + p.x1 + ' ' + p.y1 + ' L ' + endpoint.x + ' ' + endpoint.y;
  return path;
};

this.getEndPoints = function () {
  return _this.canvas.store.getEndPoints();
};

this.getLinks = function () {
  return _this.canvas.store.links;
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('links')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/links.html
// module id = 604
// module chunks = 0